import React from 'react';
import BaseValidator from 'services/validations/base-validator';

class OpposingPitchersValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {opposingPitchers} = this.dependencies;

        const minPitchersQuantity = opposingPitchers.getPitchersQuantity('min');
        const maxPitchersQuantity = opposingPitchers.getPitchersQuantity('max');

        if (minPitchersQuantity > maxPitchersQuantity) {
            this.addError(
                "Min number of hitters should not be more than Max value in the 'Allow hitters vs opposing pitchers' settings.",
            );
        }
    }
}

export default OpposingPitchersValidator;
